<template>
  <div>
    <group>
      <upload-file
        title="身份证人像面"
        v-model="formData.idCardRPic"
        :params="params"
        :max="1"
      ></upload-file>
    </group>
    <group>
      <upload-file
        title="身份证g国徽面"
        v-model="formData.idCardPic"
        :params="params"
        :max="1"
      ></upload-file>
    </group>
    <div class="button-bottom-wrap">
      <button class="button-bottom" @click="submit">保存</button>
    </div>
  </div>
</template>

<script>
import UploadFile from "@/components/Upload/UploaderFile";
import { getIdCardDetail, uploadIdCard } from "@/api/client";
export default {
  components: { UploadFile },
  data() {
    return {
      params: {
        path: "/credit-card"
      },
      formData: {
        idCardRPic: [],
        idCardPic: []
      }
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      getIdCardDetail()
        .then(res => {
          if (res.idCardRPic) {
            this.formData.idCardRPic = [res.idCardRPic];
          }
          if (res.idCardPic) {
            this.formData.idCardPic = [res.idCardPic];
          }
        })
        .catch(e => {
          this.$showError(e);
        });
    },
    submit() {
      if (
        this.formData.idCardRPic.length === 0 ||
        this.formData.idCardPic.length == 0
      ) {
        this.$showError("请上传身份证");
        return;
      }
      this.$vux.loading.show({
        text: "加载中"
      });
      uploadIdCard({
        idCardRPic: this.formData.idCardRPic[0],
        idCardPic: this.formData.idCardPic[0]
      })
        .then(() => {
          this.$showError("更新成功");
        })
        .catch(e => {
          this.$showError(e);
        })
        .finally(() => {
          this.$vux.loading.hide();
        });
    }
  }
};
</script>

<style></style>
